import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanMatch, GuardResult } from '@angular/router';
import { SecurityService } from 'app/core/security/security.service';

@Injectable()
export class MobileScanningGuard implements CanActivate, CanLoad, CanMatch {
    constructor(
        private sec: SecurityService
        , private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult { return this.check(state.url); }

    // canLoad and canMatch only see the segments matched so far, so they judge the whole URL being opened.
    canLoad(): GuardResult { return this.check(this.navigationUrl()); }

    canMatch(): GuardResult { return this.check(this.navigationUrl()); }

    private check(url: string): GuardResult {
        // If trying to access a mobile scanning route without being logged in or not in mobile scanning mode, redirect to login
        // Note: comment out the following if block if you want to access this route on desktop
        if (url.includes('/mobile-scanning') && (!this.sec.isLoggedOn() || !this.sec.isMobileScanningMode())) {
            return this.sec.loginUrlTree(url);
        }

        // If in mobile scanning mode, block non-mobile scanning routes
        if (this.sec.isMobileScanningMode() && !url.includes('/mobile-scanning')) {
            return this.router.createUrlTree(['/mobile-scanning']);
        }
        return true;
    }

    private navigationUrl(): string {
        const navigation = this.router.currentNavigation();
        return navigation ? this.router.serializeUrl(navigation.extractedUrl) : '';
    }
}
